import React from 'react';
import CustomRect from './CustomRect';
import { isDummyDuct } from '../../../../builders/dummyDucts';

const localStrokeWidth = 0.2;

// Real ducts: solid teal. Placeholder ducts: light fill + dashed outline.
const ductStyle = (duct) =>
  isDummyDuct(duct)
    ? { fill: '#CFE0E0', stroke: '#5C9495', strokeWidth: 1.5, dash: [8, 6] }
    : { fill: '#5C9495', stroke: '#333', strokeWidth: localStrokeWidth };

const CustomCabinet = React.memo(({ x, y, width, height, montagePlate, ductTopEnclosure, ductLeft, ductRight }) => {
  const topHeight = ductTopEnclosure?.size?.height ?? 0;

  return (
    <>
      {/* Montage Plate */}
      {montagePlate && (
        <CustomRect
          x={x + montagePlate.position.x}
          y={y + montagePlate.position.y}
          width={montagePlate.size.width}
          height={montagePlate.size.height}
          fill="#D9D9D9"
          stroke="#666"
          strokeWidth={localStrokeWidth}
        />
      )}

      {/* Top Duct */}
      {montagePlate && ductTopEnclosure && (
        <CustomRect
          x={x + montagePlate.position.x}
          y={y + montagePlate.position.y}
          width={ductTopEnclosure.size.width}
          height={ductTopEnclosure.size.height}
          {...ductStyle(ductTopEnclosure)}
        />
      )}

      {/* Left Duct */}
      {montagePlate && ductLeft && (
        <CustomRect
          x={x + montagePlate.position.x}
          y={y + montagePlate.position.y + topHeight}
          width={ductLeft.size.width}
          height={ductLeft.size.height}
          {...ductStyle(ductLeft)}
        />
      )}

      {/* Right Duct */}
      {montagePlate && ductRight && (
        <CustomRect
          x={x + montagePlate.position.x + montagePlate.size.width - ductRight.size.width}
          y={y + montagePlate.position.y + topHeight}
          width={ductRight.size.width}
          height={ductRight.size.height}
          {...ductStyle(ductRight)}
        />
      )}
    </>
  );
});

export default React.memo(CustomCabinet);
